import React from 'react';
import styles from './index.module.css';
console.log(styles);
const Version = () => <div className={styles.version}>Version: {process.env.REACT_APP_VERSION}</div>;

export default Version;